import { get } from 'lodash';
import { schema } from 'normalizr';

import { PayloadApiRequest } from '../actions/sagaApi';

import appointmentsResource from './appointmentsResource';
import appointmentTypesResource from './appointmentTypesResource';
import createResource from './createResource';
import facilitiesResource from './facilitiesResource';
import offersResource from './offersResource';
import patientsResource from './patientsResource';
import providersResource from './providersResource';
import { EntityID, Referral } from './types';
import usersResource from './usersResource';

const referralsResource = createResource<Referral>({
  key: 'referrals',
  url: '/referrals',
  fetchPageUrl: '/referrals/crudList',
  lookups: {
    appointmentType: appointmentTypesResource,
    facility: facilitiesResource,
    patient: patientsResource,
    provider: providersResource,
    referringProviderId: providersResource,
    schedulableProviders: { ...providersResource, schema: new schema.Array(providersResource.schema) },
    scheduledByAppointment: appointmentsResource,
    scheduledByOffer: offersResource,
    user: usersResource,
  },
});

const customActions = {
  scheduleReferral: (id: EntityID, payload?: PayloadApiRequest<Referral>) =>
    referralsResource.request({
      url: `${referralsResource.url}/${id}`,
      method: 'put',
      data: {
        status: 'scheduled',
        _id: id,
      },
      ...payload,
      meta: {
        schema: referralsResource.schema,
        messageSuccess: 'Referral scheduled successfully',
        ...get(payload, 'meta'),
      },
    }),
};

export default {
  ...referralsResource,
  ...customActions,
};
